import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle } from 'lucide-react';
export function WhyAdviceFails() {
  return <section className="py-12 px-4 bg-cream" data-id="element-442">
      <div className="max-w-4xl mx-auto" data-id="element-443">
        <FadeIn data-id="element-444">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-800 mb-8 text-center" data-id="element-445">
            Why Generic CPAP Advice Keeps Failing You
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-446">
          <FadeIn delay={100} data-id="element-447">
            <div className="space-y-6" data-id="element-448">
              <p className="text-lg-body text-text-body" data-id="element-449">
                Most CPAP content treats your problem like it's one of these:
              </p>
              <ul className="space-y-3" data-id="element-450">
                {['You need more discipline', 'You need one magic mask', 'You need to "push through discomfort"'].map((item, i) => <li key={i} className="flex items-center text-text-body bg-white p-3 rounded shadow-sm border border-gray-100" data-id="element-451">
                    <span className="text-red-400 mr-3" data-id="element-452">✕</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={200} data-id="element-453">
            <div className="space-y-6" data-id="element-454">
              <p className="text-lg-body text-text-body font-medium" data-id="element-455">
                But the real-world blockers for men 65+ are specific and
                repeatable:
              </p>
              <ul className="space-y-2 text-text-body" data-id="element-456">
                {['Beard leaks', "Mouth leaks that a tighter strap can't fix", 'Dry mouth caused by different root problems', 'Humidity changes that trigger rainout', 'Pressure discomfort that feels like you\'re "fighting the machine"', 'Panic-wakeups that train your body to rip the mask off'].map((item, i) => <li key={i} className="flex items-start" data-id="element-457">
                    <AlertTriangle className="text-amber-500 h-5 w-5 mr-3 mt-1 flex-shrink-0" data-id="element-458" />
                    <span data-id="element-459">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={300} data-id="element-460">
          <div className="mt-12 p-6 bg-navy-800 rounded-xl text-center" data-id="element-461">
            <p className="text-xl text-white font-medium" data-id="element-462">
              And here's what nobody tells you:
            </p>
            <p className="mt-4 text-lg text-blue-100 max-w-2xl mx-auto" data-id="element-463">
              If you try to fix those in the wrong order, you can spend weeks
              "trying everything"… and still end up quitting.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}